import React, { Fragment, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DateFilterContent, Divider, DynamicRangeSection, QuickFilterSection, StyledDateFilter } from './DateFilter.styles';
import { DateFilterButton } from './DateFilterButton';
import { DateFilterColumn } from './DateFilterColumn';
import { QuickFilterItem } from './QuickFilterItem';
import { Collapsible } from '../Collapsible/Collapsible';
import { DateRangePicker } from '../DatePicker/DateRangePicker';
import { Histogram } from '../Histogram/Histogram';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DateFilter = ({
  title,
  selection,
  dates = [],
  quickFilters = [],
  markedDates = {},
  isLoading,
  oldestResultDate,
  onChange,
  alwaysOpen = false
}) => {
  const {
    t
  } = useTranslation();
  const [isOpen, setOpen] = useState(alwaysOpen);
  const [openAfterLoading, setOpenAfterLoading] = useState(false);
  const onRangeSelected = dateRange => {
    onChange(dateRange);
    if (!alwaysOpen) {
      setOpen(false);
    }
  };
  const onToggle = () => {
    if (!alwaysOpen) {
      if (isLoading && !isOpen) {
        setOpenAfterLoading(true);
      } else {
        setOpen(!isOpen);
      }
    }
  };
  useEffect(() => {
    if (!isLoading && openAfterLoading) {
      setOpen(true);
      setOpenAfterLoading(false);
    }
  }, [isLoading, openAfterLoading]);
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(StyledDateFilter, {
      children: /*#__PURE__*/_jsx(DateFilterButton, {
        text: title,
        isOpen: isOpen,
        alwaysOpen: alwaysOpen,
        onClick: onToggle,
        isLoading: openAfterLoading
      })
    }), /*#__PURE__*/_jsx(Collapsible, {
      isOpen: isOpen,
      children: /*#__PURE__*/_jsxs(DateFilterContent, {
        children: [/*#__PURE__*/_jsx(DateFilterColumn, {
          heading: t('search.dateRangeHeading'),
          children: /*#__PURE__*/_jsx(QuickFilterSection, {
            children: quickFilters.map(item => /*#__PURE__*/_jsx(QuickFilterItem, {
              isSelected: item.isSelected,
              textKey: item.textKey,
              count: item.count,
              onClick: () => onRangeSelected({
                from: item.from,
                to: item.to
              })
            }, item.textKey))
          })
        }), /*#__PURE__*/_jsx(DateFilterColumn, {
          heading: t('search.manualRangeHeading'),
          children: /*#__PURE__*/_jsxs(DynamicRangeSection, {
            children: [/*#__PURE__*/_jsx(DateRangePicker, {
              range: selection,
              markedDates: markedDates,
              revealButtonText: t('search.selectFreeDateRange'),
              onChange: result => onRangeSelected(result),
              quickSelectText: t('search.oldestResult'),
              quickSelectDate: oldestResultDate
            }), /*#__PURE__*/_jsx(Histogram, {
              dates: dates,
              onClick: bar => onRangeSelected({
                from: bar.from,
                to: bar.to
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Divider, {})]
      })
    })]
  });
};